<template>
  <div class="bg">
    <div class="button">
      <div class="search" @click="showSearch = true"></div>
      <i @click="showSearch = true" class="iconfont icon-chaxun"></i>
      <router-link :to="{ path: `/enterpriseInfo/essentialInfo/${0}` }">
        <i class="iconfont icon-add" />
      </router-link>
      <!-- <i class="iconfont icon-shanchu" @click="deleteSelect()" /> -->
      <van-popup
        v-model="showSearch"
        round
        position="bottom"
        :style="{ height: 'auto' }"
        closeable
      >
        <van-field
          v-model="name"
          clearable
          label="企业名称："
          placeholder="请输入要查询的企业名称"
        />
        <van-field
          v-model="code"
          clearable
          label="信用代码："
          placeholder="请输入要查询的企业统一社会信用代码"
        />
        <div class="searchBtn">
          <el-button type="primary" size="mini" @click="itemList"> 查询企业 </el-button>
        </div>
      </van-popup>
    </div>
    <div v-show="showPagination !== 0">
      <div>

      </div>
        <div v-for="(item, index) in itemInfo" :key="index" class="content">
            <el-card>
                <el-row>
                  <div @click="goDetail(item.id)">
                    <el-col :span="24">
                      <span>企业名称：{{ item.name }}</span>
                    </el-col>
                    <el-col :span="24">
                      <span>信用代码：{{ item.code }}</span>
                    </el-col>
                    <el-col :span="24">
                      <span>企业类型：{{ item.typeName }}</span>
                    </el-col>
                    <el-col :span="24">
                      <span>法人姓名：{{ item.legalPerson }}</span>
                    </el-col>
                    <el-col :span="24">
                      <span>联系电话：{{ item.legalPhone }}</span>
                    </el-col>
                    <el-col :span="24">
                      <span>创建时间：{{ item.createTime }}</span>
                    </el-col>
                  </div>
                  <div class="handleBtn">
                    <el-col :span="24">
                      <!-- <el-button
                        size="mini"
                        type="danger"
                        @click="deleteItem(item.id)"
                      >
                        删除
                      </el-button> -->
                      <!-- <router-link :to="{ path: 'itemInfo/essentialInfo' }"> -->
                      <el-button v-if="item.isDisabled == 1" size="mini" type="primary" @click="goEdit(item.id)">
                        修改
                      </el-button>
                      <!-- </router-link> -->
                      <el-button size="mini" type="primary" @click="goDetail(item.id)">
                        详情
                      </el-button>
                    </el-col>
                  </div>
                </el-row>
            </el-card>
        </div>
      <el-pagination
        :current-page.sync="page.currentPage"
        :page-sizes="page.pageSizes"
        :page-size="page.pageSize"
        :total="page.totalCount"
        layout="sizes ,pager, next "
        :on-load="itemList"
        @size-change="sizeChange"
        @current-change="currentChange"
      />
    </div>
    <el-card v-show="showPagination == 0" body-style="text-align:center">
      <span>暂无数据</span>
    </el-card>
    <div style="margin-top: 10px; text-align: right">
      <el-button v-show="showPagination == 0" size="mini" type="primary" @click="goBack">
        返回
      </el-button>
    </div>
  </div>
</template>
<script>
import { postDictCode } from "@/api/dict";
import { postProjectId } from "@/api/app/project";
import { postListPage, postRemove } from "@/api/app/enterprise";
let ids = [];
export default {
  data() {
    return {
      showSearch: false,
      // 全选
      checkedAll: false,
      name: "",
      code: "",
      // 分页
      page: {
        pageSize: 10,
        currentPage: 1,
        totalCount: 0,
        pageSizes: [10, 20, 30, 40, 50, 100],
      },
      // 参建单位信息
      itemInfo: {},
      checkedOne: [],
      isIndeterminate: false,
      query: {},
      showPagination: Number,
      searchText: "",
      enterpriseTypeOptions: [],
    };
  },
  created() {
    this.itemList();
  },

  computed: {},
  methods: {
    // 参建单位列表
    itemList(page, params = {}) {
      if (this.name !== "") {
        this.query.name = this.name;
      } else if (this.code !== "") {
        this.query.code = this.code;
      }
      postListPage(
        this.page.currentPage,
        this.page.pageSize,
        Object.assign(params, this.query)
      ).then((res) => {
        this.page = res.data;
        this.showPagination = res.data.result.length;
        this.showSearch = false;
        if (res.data.result.length !== 0) {
          // 获取字典信息，根据字典信息匹配进场状态
          postDictCode("enterprise_type").then((resType) => {
            this.$store.commit("Dict", resType.data);
            res.data.result.forEach((item) => {
              resType.data.find((items) => {
                if (item.type == items.value) {
                  item["typeName"] = items.label;
                  this.itemInfo = res.data.result;
                }
              });
            });
          });
        } else {
          this.$notify({ type: "warning", message: "查询内容无数据" });
        }
      });
    },
    // 返回
    goBack() {
      if (this.name !== "" || this.code !== "") {
        location.reload();
      } else {
        this.$router.back();
      }
    },
    // 跳转到参建单位详情
    goDetail(id) {
      this.$store.commit("ItemId", id);
      this.$router.push({ path: "enterpriseInfo/detailedInfo" });
    },
    // 跳转到参建单位编辑
    goEdit(id) {
      this.$store.commit("ItemId", id);
      this.$router.push({ path: `enterpriseInfo/essentialInfo/${1}` });
    },
    // 删除具体参建单位
    deleteItem(ids) {
      this.$dialog
        .confirm({
          message: "确定删除吗？",
        })
        .then(() => {
          postRemove([ids]).then((res) => {
            this.$notify({ type: "success", message: "删除成功！" });
            this.itemList();
          });
        });
    },
    // // 删除选中
    // deleteSelect() {
    //   this.$dialog
    //     .confirm({
    //       message: "确定删除吗？",
    //     })
    //     .then(() => {
    //       postRemove(ids).then((res) => {
    //         this.$notify({ type: "success", message: "删除成功！" });
    //         this.itemList();
    //       });
    //     });
    // },
    // 左滑删除参建单位
    beforeClose({ position, instance, name }) {
      switch (position) {
        case "right":
          this.$dialog
            .confirm({
              message: "确定删除吗？",
            })
            .then(() => {
              postRemove([name]).then((res) => {
                this.$notify({ type: "success", message: "删除成功！" });
                this.itemList();
              });
              instance.close();
            });
          break;
      }
    },
    // 分页
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.itemList(this.page);
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.itemList(this.page);
    },
    // el-card全选
   checkAll(val) {
      this.checkedOne = val ? this.itemInfo : [];
      this.isIndeterminate = false;
      if (val == true) {
        ids = this.itemInfo.map((item) => {
          return item.id;
        });
      } else {
        ids = [];
      }
    },
    // el-card选中单个
    checkOne(value) {
      let checkedCount = value.length;
      this.checkedAll = checkedCount === this.itemInfo.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.itemInfo.length;
      ids = value.map((item) => {
        return item.id;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  padding: 10px;
  min-height: 100vh;
  margin-bottom: 60px;
  background-color: #f0f0f0;
}
span{
  font-size: 14px;
}
.button {
  width: 100%;
  display: flex;
  text-align: right;
  margin-bottom: 10px;
  align-items: center;
  .search {
    width: inherit;
  }
  i {
    font-size: 24px;
    color: #606266;
  }
  .van-field:nth-child(1) {
    margin-top: 45px;
  }
  .searchBtn {
    margin-top: 20px;
  }
}
.el-button + .el-button {
  margin: 0;
}
/deep/ .el-checkbox__inner {
  width: 19px;
  height: 19px;
  border-radius: 50%;
}


.content {
  margin-bottom: 10px;
  .van-button {
    height: 100%;
  }
  /deep/ .el-checkbox__input {
    position: absolute !important;
    left: -10px;
  }
  .el-col {
    margin-bottom: 3px;
  }
  /deep/ .el-card__body {
    padding: 30px;
}
  .handleBtn {
    top: 20px;
    left: 20px;
    text-align: end;
    position: relative;
  }
}
// 分页
/deep/ .el-pagination {
  padding: 0;
  overflow: hidden;
}
/deep/ .el-pagination .el-select .el-input {
  margin: 0;
}
</style>
